import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/ecosystem-entities',
  name: 'ecosystemEntities',
  component: Layout,
  meta: {
    title: '生态实体',
    icon: 'i-lucide:network',
  },
  children: [
    {
      path: 'cooperative-enterprises',
      name: 'cooperativeEnterprises',
      component: () => import('@/views/ecosystem_entities/cooperative-enterprises.vue'),
      meta: {
        title: '合作企业',
        icon: 'i-lucide:building-2',
      },
    },
    {
      path: 'medical-institutions',
      name: 'medicalInstitutions',
      component: () => import('@/views/ecosystem_entities/medical-institutions.vue'),
      meta: {
        title: '医疗机构',
        icon: 'i-lucide:hospital',
      },
    },
    {
      path: 'physician-alliances',
      name: 'physicianAlliances',
      component: () => import('@/views/ecosystem_entities/physician-alliances.vue'),
      meta: {
        title: '医师联盟',
        icon: 'i-lucide:users-round',
      },
    },
    {
      path: 'patients',
      name: 'patients',
      component: () => import('@/views/ecosystem_entities/patients.vue'),
      meta: {
        title: '患者池',
        icon: 'i-lucide:user-round-search',
      },
    },
    {
      path: 'patients/import',
      name: 'patientImport',
      component: () => import('@/views/ecosystem_entities/patients/import.vue'),
      meta: {
        title: '导入患者',
        menu: false,
        activeMenu: '/ecosystem-entities/patients',
        keepAlive: false,
      },
    },
    {
      path: 'physician-alliances/create',
      name: 'physicianAllianceCreate',
      component: () => import('@/views/ecosystem_entities/physician_alliances/create.vue'),
      meta: {
        title: '医师建档',
        menu: false,
        activeMenu: '/ecosystem-entities/physician-alliances',
      },
    },
    {
      path: 'physician-alliances/:id',
      name: 'physicianAllianceDetail',
      component: () => import('@/views/ecosystem_entities/physician_alliances/[id]/index.vue'),
      meta: {
        title: '医师详情',
        menu: false,
        activeMenu: '/ecosystem-entities/physician-alliances',
      },
    },
    {
      path: 'physician-alliances/:id/edit',
      name: 'physicianAllianceEdit',
      component: () => import('@/views/ecosystem_entities/physician_alliances/[id]/edit.vue'),
      meta: {
        title: '编辑医师档案',
        menu: false,
        activeMenu: '/ecosystem-entities/physician-alliances',
      },
    },
  ],
}

export default routes
